import { useContext } from 'react';
import { OrchestrationContext } from 'js/components/pipelines/FlowNodes/context/OrchestrationContext';

export default function useOrchestration() {
  return useContext(OrchestrationContext);
}
